import StripeUtils from "../utils/stripe";

export default {
    methods: {
        async stripeHandlePaymentResponse (response, customer, card) {
            if (!customer) throw new Error('Customer Not Found');
            if (!response) throw new Error('Response Not Found');

            if (response.error) {
                return {
                    error: response.error,
                    message: response.error.message
                }
            } else if (response.stripe_intent && response.stripe_intent.status === "requires_payment_method") {
                const { stripe_intent } = response;

                if (!stripe_intent) throw new Error('No Stripe Intent Provided');

                return this.stripeHandleCardSetup(stripe_intent, customer, card);
            } else {

                const { setupIntent: intent } = response;

                if (!intent) throw new Error('No Setup Intent Provided');

                let confirmResponse = await this.confirmStripePaymentMethod({intent, customer});

                if (confirmResponse) {
                    return true;
                } else {
                    return {
                        error: confirmResponse,
                        message: 'Something went wrong'
                    }
                }
            }
        },
        async stripeHandleCardSetup (response, customer, card) {
            StripeUtils.handle3dSecureModal()
                .then(() => {
                    this.toggleLoader(false);
                })
                .catch(() => {
                    throw new Error('3d Secure Modal Closed')
                });

            return this.stripe.handleCardSetup(
                response.client_secret,
                card
            ).then((response) => {
                if (response.error) {
                    this.removeStripeCustomer(customer.id);

                    return {
                        error: response.error,
                        message: response.error.message
                    }
                } else {
                    return this.stripeHandlePaymentResponse(response, customer);
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/managers/StripeManager.js